module.exports = __webpack_public_path__ + "img/nothing.aff647ff.png";